import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'public-video-popup-example',
  templateUrl: 'public-video-popup-example.component.html',
})
export class PublicVideoPopupExampleComponent implements OnInit {
  initialized = false;

  @Input()
  videoLink: string;

  @Input()
  analysisName: string;

  @Input()
  description: string;

  @Input()
  encoded: boolean;


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
